import { api } from "shared/config/api/api";
import { PROMO_URL } from "entities/wheel-raffle";
import type {
  CreateWheelRaffleRequest,
  CreateWheelRaffleResponse,
} from "entities/wheel-raffle";

export const createWheelRaffleApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Сразу списывает prize_pool_usdt с real-баланса.
    createWheelRaffle: builder.mutation<
      CreateWheelRaffleResponse,
      CreateWheelRaffleRequest
    >({
      query: (body) => ({
        url: `${PROMO_URL}/wheel-raffles`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["WheelRaffle"],
    }),
  }),
});

export const { useCreateWheelRaffleMutation } = createWheelRaffleApi;
